import mapboxgl from 'mapbox-gl';
import {getRandomColors} from "../common/CommonFun";

/**
 * 自定义图层组件
 */
export default class BaseCustomLayer{

  constructor(id,type,data,options={}) {
    this.id=id;
    this.type=type;
    this.data=data;
    this.params={
      width: 60,//图标宽度
      height: 60,//图标高度
      clickCallBack:null,//鼠标点击事件
      overCallBack:null,//鼠标经过事件
      clickCallBackName:null,//点击触发地图事件名称
      overCallBackName:null,//鼠标经过触发地图事件名称
      chartAnchor: 'center',//锚点位置  'center' , 'top' , 'bottom' , 'left' , 'right' , 'top-left' , 'top-right' , 'bottom-left' , and 'bottom-right' 'center' , 'top' , 'bottom' , 'left' , 'right' , 'top-left' , 'top-right' , 'bottom-left' , and 'bottom-right'
      popupAnchor:"left",
      showPopup:true,
      popupClassName:"",
      popupHtmlTemplate:"<div>种类1：${val0}</div><br/><div>种类2：${val1}</div><br/><div>种类3：${val2}</div>",//"<div>种类1：${val0}</div><br/><div>种类2：${val1}</div><br/><div>种类3：${val2}</div>"
      colors:[],
      popupOffsets:{//定义统计标签弹出窗口偏移量
        'top': [0, 0],//向下显示，越正越往下
        'left': [20, 0],
        'bottom': [0, 0],
      }
    }
    Object.assign(this.params,options)
  }

  /**
   * 添加到地图
   * @param map
   */
  addToMap(map){
    this.map=map;
    this.markers=[];
    this._render();
  }

  /**
   * 生成数据对应的统计图
   * @param item
   */
  createChart(item){

  }

  /**
   * 求总和
   * @param values
   */
  sum(values){
    let sum=0;
    for (let i = 0; i <values.length ; i++) {
      sum=sum+values[i]
    }
    return sum
  }



  /**
   * 从地图移除
   */
  remove(){
    this.markers.forEach((item)=>{
      item.remove();
    })
    if(this.currentPopup) {this.currentPopup.remove()}

  }

  _render(){
    let colors=this.params.colors;
    if(this.data.length>0&&this.data[0].values.length>0){
      let item=this.data[0];
      //生成颜色
      if(!colors||colors.length===0){
        colors=getRandomColors(item.values.length)
      } else if(colors.length<item.values.length){
        colors=colors.concat(getRandomColors(item.values.length-colors.length))
      }
    }
    for (let i = 0; i < this.data.length; i++) {
      let element=this.createChart(this.data[i],colors)

      if(this.params.showPopup){
        let popupHtml = this.params.popupHtmlTemplate;

        for (let j = 0; j < this.data[i].values.length; j++) {
          popupHtml=popupHtml.replaceAll("${val"+j+"}",this.data[i].values[j]);
        }
        if(this.params.clickCallBack||this.params.clickCallBackName){
          element.addEventListener('mousedown',  ()=> {
            this._clickCallback(this.data[i]);
          });
        }
        //绑定当前要素统计标签的鼠标移动事件
        element.addEventListener('mouseover',  ()=> {
          if(this.currentPopup) {this.currentPopup.remove();}
          this.currentPopup = new mapboxgl.Popup({offset: this.params.popupOffsets,closeButton: false,anchor: this.params.popupAnchor, className: this.params.popupClassName})
            .setLngLat(this.data[i].point)
            .setHTML(popupHtml)
            .addTo(this.map);

          this._overCallback(this.data[i])
        });
        // 绑定当前要素统计标签的鼠标移出事件
        element.addEventListener('mouseout',  ()=> {
          this.currentPopup.remove();
        });
      }

      //添加marker
      let marker = new mapboxgl.Marker({
        element: element,
        anchor: this.params.chartAnchor,
      }).setLngLat(this.data[i].point).addTo(this.map);
      this.markers.push(marker)
    }

  }



  _clickCallback(data){
    if(this.params.clickCallBack){
      this.params.clickCallBack(data)
    }
    if(this.params.clickCallBackName){
      this.map.fire(this.params.clickCallBackName,data)
    }
  }
  /**
   * 点击标签回调触发
   * @param data
   * @private
   */
  _overCallback(data){
    if(this.params.overCallBack){
      this.params.overCallBack(data)
    }
    if(this.params.overCallBackName){
      this.map.fire(this.params.overCallBackName,data)
    }
  }
}



// WEBPACK FOOTER //
// ./src/layer/BaseCustomLayer.js